export enum HotelCategoryId {
  NoStars = 0,
  OneStar = 1,
  TwoStars = 2,
  ThreeStars = 3,
  FourStars = 4,
  Apartments = 5,
  Villas = 6,
  FiveStars = 7,
  FiveStarsHv1 = 8,
  FourStarsHv2 = 9,
  Hostel = 10,
  Villa = 11,
  ClubHotel = 12,
  ApartHotel = 13,
  HotelComplex = 14,
  ResortTown = 15,
  Sanatorium = 16,
  BoardingHouse = 17,
  RestHouse = 18,
  RecreationCenter = 19,
  GuestHouse = 20,
  Hotel = 21,
  BoutiqueHotel = 22,
  ExcursionProgram = 23,
}

export interface HotelCategoryData {
  id: number;
  name: string;
  stars: number;
}
